import { reduxForm } from 'redux-form';

import TargetForm from './TargetForm';

export default reduxForm({ form: 'targetForm' })(TargetForm as any) as any;
